import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const walletStatusService = {
  getWalletStatus
};

function getWalletStatus(params) {
  return apiCall("GET", apiUrls.status.wallet, null, params);
}
